import { CommandProps } from '@tiptap/core';
import { Node } from '@tiptap/pm/model';

import { sectionManagerKey, TSectionMeta } from '../SectionNode';

/**
 * Unwrap all landscape sections in the document.
 *
 * This is used when switching from portrait to landscape mode.
 * The unwrap transaction is excluded from history (addToHistory: false)
 * so users cannot undo the mode switch but can still undo previous edits.
 *
 * @returns true if any sections were unwrapped, false if no sections exist
 */
const unwrapAllSectionsCommand =
  () =>
  ({ state, tr, dispatch }: CommandProps) => {
    const sections: { pos: number; node: Node }[] = [];

    // Find all section nodes in the document
    state.doc.descendants((node, pos) => {
      if (node.type.name === 'section') {
        sections.push({ pos, node });
      }
    });

    // No sections to unwrap
    if (sections.length === 0) {
      return false;
    }

    // Set delta meta for O(1) section count update (removing all sections)
    tr.setMeta(sectionManagerKey, { delta: -sections.length } as TSectionMeta);

    // Process in reverse order to maintain correct positions
    // (unwrapping earlier nodes would shift positions of later nodes)
    sections.reverse().forEach(({ pos, node }) => {
      tr.replaceWith(pos, pos + node.nodeSize, node.content);
    });

    // Exclude from history so users can't undo the mode switch
    tr.setMeta('addToHistory', false);

    if (dispatch) {
      dispatch(tr);
    }

    return true;
  };

export default unwrapAllSectionsCommand;
